import { mainPageAnimation } from './main-page.animation';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BackgroundPlayerComponent, DwallClickableMediaDirective } from '@core';
import { TabBarComponent } from '@app/components/tab-bar/tab-bar.component';

@Component({
  selector: 'app-main',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  animations: [
    mainPageAnimation,
  ],
  imports: [
    RouterOutlet,
    TabBarComponent,
    BackgroundPlayerComponent,
    DwallClickableMediaDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {}
